export function mdtSelectionDecoratorConfig($provide) {
  'ngInject';
  $provide.decorator('mdtAjaxPaginationHelperFactory', ($delegate, MdtSelectionStore) => {
    'ngInject';
    const originalGetInstance = $delegate.getInstance;
    $delegate.getInstance = params => {
      const selectionKey = params && params.mdtRowOptions ? params.mdtRowOptions.selectionKey : null;
      const dataStorage = params ? params.dataStorage : null;
      if (selectionKey && dataStorage && !dataStorage.__selectionPatched) {
        dataStorage.__selectionPatched = true;
        const originalAddRowData = dataStorage.addRowData.bind(dataStorage);
        dataStorage.addRowData = (rowId, rowArray, className) => {
          originalAddRowData(rowId, rowArray, className);
          const last = dataStorage.storage[dataStorage.storage.length - 1];
          if (last && String(last.rowId) === String(rowId)) {
            last.optionList.selected = MdtSelectionStore.has(selectionKey, rowId);
          }
        };
      }

      return originalGetInstance(params);
    };

    return $delegate;
  });
}
